import Vue from "vue/dist/vue.esm.js";
import Vuex from "vuex";
// 持久化存储插件
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

import user from "./user";

// 根状态
const state = {
    messageData: {},
    dictData: {},
    selectData: {},
    staticVarData: {},
    objVarData: {}
};

const mutations = {
    SET_STATICVARDATA(state, staticVarData) {
        state.staticVarData = staticVarData || {};
    },
    SET_MESSAGEDATA(state, messageData) {
        state.messageData = messageData || {};
    },
    SET_DICTDATA(state, dictData) {
        state.dictData = dictData || {};
    },
    SET_SELECTDATA(state, selectData) {
        state.selectData = selectData || {};
    },
    SET_OBJVARDATA(state, objVarData) {
        state.objVarData = objVarData || {};
    }
};

const actions = {
    setStaticVarData({ commit }, payload) {
        commit("SET_STATICVARDATA", payload);
    },
    setMessageData({ commit }, payload) {
        commit("SET_MESSAGEDATA", payload);
    },
    setDictData({ commit }, payload) {
        commit("SET_DICTDATA", payload);
    },
    setSelectData({ commit }, payload) {
        commit("SET_SELECTDATA", payload);
    },
    setObjVarData({ commit }, payload) {
        commit("SET_OBJVARDATA", payload);
    }
};

const getters = {
    getStaticVarData(state) {
        return state.staticVarData;
    },
    getMessageData(state) {
        return state.messageData;
    },
    getDictData(state) {
        return state.dictData;
    },
    getSelectData(state) {
        return state.selectData;
    },
    getObjVarData(state) {
        return state.objVarData;
    }
};

// 用户信息等状态放在根状态下，其他模块如果添加必须使用namespaced:true，避免出现命名冲突
const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        user
    },
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
            reducer(val) {
                return {
                    // 只储存state中的user
                    user: val.user
                };
            }
        })
    ]
});

export default store;
